const state = {
    user: null,
    chips: null,
    token: null,
    eventManage:null,
    eventDetailHideSections: [],
    is_offer: true

};
const getters = {
    isAuthenticated: state => !!state?.user,    
    stateUser: state => state?.user,
    chips: state => state?.chips,
    token: state => state?.token,
    eventManage: state => state?.eventManage,
    eventDetailHideSections: state => state?.eventDetailHideSections,
    is_offer: state => state?.is_offer,
};
const actions = {
    setUser ({ commit},user) {
        commit('setUser',user);
    },
    setChips({ commit }, chips) {
        commit('setChips', chips);
    },
    setToken({ commit }, token) {
        commit('setToken', token);
    },
    setEventManage({ commit }, token) {
        commit('setEventManage', token);
    },seteventDetailHideSections({ commit }, filter) {
        commit('seteventDetailHideSections', filter);
    },
    setIs_offer({ commit }, is_offer) {
        commit('setIs_offer', is_offer);
    },
};
const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setChips(state, chips) {
        state.chips = chips
    },
    setToken(state, token) {
        state.token = token;
    },
    setEventManage(state, eventManage) {
        state.eventManage = eventManage;
    },seteventDetailHideSections(state, eventDetailHideSections) {
        state.eventDetailHideSections = eventDetailHideSections;
    },
    setIs_offer(state, is_offer) {
        state.is_offer = is_offer;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};